import { List, Text, IconTick } from 'braid-design-system';
import React from 'react';

type Props = {
  items: Array<string>;
  space?: 'medium' | 'large';
};

export const BenefitList = ({ items, space = 'medium' }: Props) => (
  <List
    type="icon"
    size="large"
    space={space}
    icon={<IconTick tone="info" alignY="lowercase" />}
  >
    {items.map((item) => (
      <Text key={item} size="standard">
        {item}
      </Text>
    ))}
  </List>
);
